import { rafaelImage, whatsappUrl, instagramUrl } from "../mock";
import { Award, Users, Star, MessageCircle, Instagram } from "lucide-react";

export default function Executive() {
  return (
    <section id="executivo" className="py-20 dark-green-section">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-emerald-500/30 bg-emerald-500/10 text-emerald-400 text-xs font-semibold mb-4">
            Seu Gestor
          </div>
          <h2 className="text-white text-3xl md:text-5xl font-extrabold leading-tight">
            Conheça Quem Vai <span className="gold-gradient-text">Te Acompanhar</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/30 to-amber-500/20 blur-3xl -z-0" />
            <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-2xl aspect-[4/5] max-w-md mx-auto">
              <img
                src={rafaelImage}
                alt="Rodney Espindola - Gestor iGreen Energy"
                className="w-full h-full object-cover"
              />
              <div className="absolute top-4 left-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-amber-400 text-black text-xs font-bold">
                <Award className="w-3.5 h-3.5" /> Gestor Reconhecido
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-white text-4xl font-extrabold">Rodney Espindola</h3>
            <p className="text-emerald-400 font-semibold mt-1">Gestor</p>
            <p className="mt-5 text-slate-300 leading-relaxed">
              Rodney Espindola é um Gestor reconhecido pela iGreen Energy pelo seu sucesso e dedicação em ajudar novos licenciados a construirem suas carreiras no setor de energia. Com vasta experiência no mercado, ele será seu mentor durante toda a jornada.
            </p>

            <div className="mt-6 flex flex-wrap gap-3">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-slate-200 text-sm">
                <Star className="w-4 h-4 text-amber-400" /> Reconhecido
              </div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-slate-200 text-sm">
                <Users className="w-4 h-4 text-emerald-400" /> Líder de Equipe
              </div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-slate-200 text-sm">
                <Award className="w-4 h-4 text-amber-400" /> Top Performer
              </div>
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <a href={whatsappUrl} target="_blank" rel="noreferrer" className="btn-gold inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm">
                <MessageCircle className="w-4 h-4" /> Falar com Rodney
              </a>
              <a href={instagramUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-6 py-3 rounded-xl border border-white/20 text-white hover:bg-white/10 text-sm font-semibold transition-colors">
                <Instagram className="w-4 h-4" /> @igreenenergy.rodney
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
